/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { History } from "history";
import { useTranslation } from "react-i18next";
import { FUNCTIONS } from "../../../firebase/functions";
import Axios from "axios";
import queryString from "query-string";
import { signInWithLinkedIn } from "../../../context/auth/action";
import { ROUTES } from "../../../routing/routes";
import { AuthState } from "../../../context/auth/auth/reducer";
import { Link, useHistory } from "react-router-dom";
import _environment from "../../../_environment/_environment";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
}

const LinkedInView = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Reference to Redux store dispatch function: use it to dispatch actions.
  const dispatch = useDispatch();

  // Access to the history instance that you may use to navigate.
  let history = useHistory();

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [message, setMessage] = useState<string>("forms.linkedin.waiting_for_linkedin");
  const [userName, setUserName] = useState<string | null>(null);
  const [error, setError] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Returns the value of the given URL query parameter.
   * @function
   *
   * @param name
   */
  const getURLParameter = (name: string) => {
    try {
      const params = queryString.parse(history.location.search);
      return params[name];
    } catch (err) {
      return null;
    }
  };

  /**
   * Starts the linkedin auth flow, communicates with cloud functions
   * @function
   * @async
   */
  const initLinkedInFlow = async () => {
    // Linkedin redirect parameters
    const code = getURLParameter("code");
    const state = getURLParameter("state");
    const error = getURLParameter("error");
    const errorDesc = getURLParameter("error_description");

    if (error) {
      console.error(error);
      console.log(errorDesc);
      setError(true);
      return;
    } else {
      setError(false);

      if (!code) {
        // Start the auth flow. Redirect to a cloud function
        window.location.href = `${_environment.firebase.functionsURL}/${FUNCTIONS.LINKEDIN_REDIRECT}`;
        return;
      } else {
        // Change loading message
        setMessage("forms.linkedin.waiting_for_auth");

        // This is the URL to the HTTP triggered 'token' Firebase Function.
        var tokenFunctionURL = `${_environment.firebase.functionsURL}/${FUNCTIONS.LINKEDIN_TOKEN}`;

        try {
          // Retrieve user data
          const response = await Axios.get(tokenFunctionURL, {
            params: {
              state: state,
              code: code,
            },
          });

          if (response.status === 200) {
            setUserName(response.data.userData.firstname);

            // Change loading message
            setMessage("forms.linkedin.almost_done");

            dispatch(signInWithLinkedIn(response.data));
          } else {
            console.error(response.data);
            setError(response.data);
          }
        } catch (err) {
          console.error(err);
          setError(true);
        }

        return;
      }
    }
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    console.log("[LinkedInView] init");

    initLinkedInFlow();
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    console.log("[LinkedInView] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to user in order to handle authorization
   */
  useEffect(() => {
    if (user) {
      history.push(ROUTES.HOME);
    }
  }, [user, history]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------

  return (
    <div className="main-content linkedin">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-7 col-md-9">
            <div className="box o-hidden my-5">
              <div className="logo-vertical-wrapper">
                <img src="assets/images/logo_meeters_horizontal.png" alt="Meeters"/>
              </div>
              <div className="card-body p-0">
                <div className="p-4">
                  <div className="text-center">
                    <h1 className="h4 text-gray-900 mb-4">
                      <i className="fab fa-linkedin"></i>
                      LinkedIn Login
                    </h1>
                  </div>

                  {!error && (
                    <div className="description text-center">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t(message, {
                            name: `<strong>${userName}</strong>`,
                          }),
                        }}
                      ></span>
                      <div className="loader">
                        <i className="fas fa-spinner fa-spin"></i>
                      </div>
                    </div>
                  )}

                  {!!error && (
                    <>
                      <div className="description text-center danger">
                        <span>An error occurred</span>
                        <hr/>
                      </div>

                      <div className="text-center">
                        <Link to={ROUTES.SIGN_IN}>
                          <span className="small">{t("forms.back_sign_in")}</span>
                        </Link>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LinkedInView;
